import React from 'react'

export const ShareOrigin = () => {
  return window.SHARE_ORIGIN
}